import React from "react";
import ReactDOM from "react-dom/client";
import { getDefaultStore } from "jotai";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "@/design-system/assets/fonts/fonts.css";
import "./index.css";
import "./lib/commands";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import { getRuntimeConfig } from "./config/api";
import { gpuVerdictAtom, gpuVerdictReasonAtom } from "./atoms/gpuVerdictAtom";
import { runGpuProbeDetailed, defaultCreateContext } from "./utils/gpuVerdict";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

// Run the GPU probe BEFORE first render so deep-link page loads to a case
// URL don't briefly mount VolumeViewport on hardware that can't sustain it.
// A useEffect-based wiring would let CaseViewer/ProtocolViewport mount one
// frame with the default "volume-ok" verdict, which is exactly the path
// that triggers CONTEXT_LOST_WEBGL on Intel UHD + ANGLE/D3D11. Module-load
// bootstrap eliminates that flash.
const bootVerdict = runGpuProbeDetailed({
  location: window.location,
  overrideStorage: window.localStorage,
  cacheStorage: window.sessionStorage,
  createContext: defaultCreateContext,
});
getDefaultStore().set(gpuVerdictAtom, bootVerdict.verdict);
getDefaultStore().set(gpuVerdictReasonAtom, bootVerdict.reason);

// Derive API base URL, then render immediately.
// Cognito config is loaded lazily by PrivateRoute and Login when needed.
getRuntimeConfig().then(() => {
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </HelmetProvider>
    </React.StrictMode>,
  );
});

reportWebVitals();
